// extracted by mini-css-extract-plugin
export default {"placeholder":"Hokg2kaPwBcOchhCvBjDiw==","avatar":"HGfJnGbKD+W7K1oTzIV6-w=="};